import { render } from "./faqManagement.vue?vue&type=template&id=8511ada8"
import script from "./faqManagement.vue?vue&type=script&lang=js"
export * from "./faqManagement.vue?vue&type=script&lang=js"

import "./faqManagement.vue?vue&type=style&index=0&id=8511ada8&lang=less"
script.render = render

export default script